// ajax类
import qs from 'qs'

// 计算当前URL
function setUrl (that) {
  let apiUrl
  if (window.location.href.indexOf('wechat') >= 0) {
    apiUrl = 'https://maximum_api.bei-lin.cn/'
  } else {
    apiUrl = 'http://localhost/index.php/'
  }
  that.$root.apiUrl = apiUrl
  return apiUrl
}

// 按类型启用/停止加载中
function setLoading (that, LoadingType, type = false) {
  // 全部加载
  if (LoadingType === 'all') {
    that.$root.loadingAll = type
  }

  // 加载数据
  if (LoadingType === 'data') {
    that.ifData = type
  }

  // 锁定按钮
  if (LoadingType === 'on') {
    that.ifOn = type
  }

  // 备用1
  if (LoadingType === 'one') {
    that.ifLone = type
  }

  // 备用2
  if (LoadingType === 'tow') {
    that.ifLtwo = type
  }
}

export default {
  install (Vue, options) {
    Vue.prototype.apiUrl = '' // API地址
    Vue.prototype.ifData = false // 加载数据 'data'
    Vue.prototype.ifOn = false // 锁定按钮 'on'
    Vue.prototype.ifLone = false // 备用1 'one'
    Vue.prototype.ifLtwo = false // 备用2 'tow'

    /**
     * that this
     * url 接口地址（区别部分）
     * data post的数据
     * successfn 接收回参
     * LoadingType 加载类型
     * addToken 是否附带token 默认true
     */
    Vue.prototype.ax = (that, url, data, successfn, LoadingType = null, addToken = true) => {
      let apiUrl = setUrl(that)
      setLoading(that, LoadingType, true)

      // 判断组装token
      if (addToken) {
        data.token = that.$cookies.get('token')
        if (data.token === null) {
          setTimeout(() => {
            that.ax(that, url, data, successfn, LoadingType, addToken)
          }, 500)
          return
        }
      }

      data.lt = 101 // 默认中文
      that.axios.post(apiUrl + url, qs.stringify(data)).then((res) => {
        // 错误提示
        if (res.data.err_num === 1) {
          // 系统错误
          that.$notify({ type: 'danger', message: res.data.msg + '，请联系油站管理员' })
        } else if (res.data.err_num === 2) {
          // 操作提示
          that.$notify({ type: 'warning', message: res.data.msg })
        } else {
          // 固定报错
          if (res.data.err_num === 200) {
            // token失效
            that.$cookies.remove('token')
            that.$dialog({
              message: '您的登录信息已失效，请重新进入',
              confirmButtonText: '关闭页面'
            }).then(() => {
              global.wx.closeWindow()
            })
          }
        }
        setLoading(that, LoadingType)
        successfn(res.data)
      }).catch(() => {
        setLoading(that, LoadingType)
        that.$notify({ type: 'warning', message: '当前网络拥堵，请稍后重试' })
        successfn({err_num: 404})
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/ajax.js